import { Injectable, TemplateRef } from '@angular/core';
import { MentorshipTypeEnum } from '@app/mentoring/mentoring.enums';
import { MentorshipType } from '@app/mentoring/mentoring-api.model';
import {
  DataColumn,
  DataColumnDate,
  DataColumnList,
  DataColumnPerson,
} from '@app/shared/components/data-table/data-table';

@Injectable({
  providedIn: 'root',
})
export class MentoringService {
  public getColumnConfig(
    type: MentorshipType,
    contactTemplate: TemplateRef<HTMLElement>,
    statusTemplate: TemplateRef<HTMLElement>
  ) {
    const hideMentoringIcon = type === MentorshipTypeEnum.Mentee;
    return [
      {
        label: 'Core_Name',
        headClasses: 'l_w25',
        bodyClasses: 'break',
        type: 'person',
        propPic: 'picture',
        propName: 'name',
        propEmail: 'jobRole',
        propHref: 'internalUrl',
        picHideMentorIcon: hideMentoringIcon,
        picMentorIconSize: 'medium',
      } as DataColumnPerson,
      {
        label: 'Core_Status',
        headClasses: 'l_w10 no-mobile',
        bodyClasses: 'no-mobile',
        template: statusTemplate,
      } as DataColumn,
      {
        label:
          type === MentorshipTypeEnum.Mentee
            ? 'Opportunities_MenteeSkills'
            : 'Opportunities_MentorSkills',
        headClasses: 'l_w25 no-mobile',
        bodyClasses: 'no-mobile',
        type: 'list',
        limit: 3,
        popoverConfig: {
          maxHeight: '200px',
        },
        prop: 'tagNames',
        usePopover: () => true,
      } as DataColumnList,
      {
        label: 'Core_Location',
        headClasses: 'l_w15 no-mobile',
        bodyClasses: 'no-mobile',
        prop: 'location',
      } as DataColumn,
      {
        label: 'Opportunities_Mentoring_Columns_Connect',
        headClasses: 'l_w15',
        template: contactTemplate,
      } as DataColumn,
      {
        label: 'Core_StartDate',
        headClasses: 'l_w15',
        prop: 'dateCreated',
        type: 'date',
        dateFormat: 'MM/dd/yy',
      } as DataColumnDate,
    ];
  }
}
